import axios from 'axios'
export default axios.create({
  baseURL: 'https://acg.ual.es/projects/cosmart/wot-lab/ds/api',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})
 